import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import { colorsModeUI } from '../../../modeUI';

import './index.css';

export const TYPE_MAIN_MENU_ITEM_LINK = 'ITEM_LINK';
export const TYPE_MAIN_MENU_ITEM = 'ITEM';

/**
 * Menu item popup
 * The popup is shown by the hover event
 * Parameters (Props):
 * @param object menuItem
 * @param object popup:  {title}
 * @param string mode
 */
export default class MenuItemPopup extends React.PureComponent {
  render() {
    const { menuItem, popup, mode } = this.props;
    const colors = colorsModeUI(mode);
    const style = {
      backgroundColor: colors.POPUP_MAIN_MENU_BACKGROUND,
      color: colors.POPUP_MAIN_MENU_COLOR,
      border: '0px',
      boxShadow: colors.POPUP_SHADOW,
    };
    const styleHeader = {
      backgroundColor: colors.POPUP_MAIN_MENU_HEADER_BACKGROUND,
      color: colors.POPUP_MAIN_MENU_HEADER_COLOR,
    };
    return (
      <Popup
        trigger={menuItem}
        on={['hover']}
        basic
        style={style}
        className="popup"
        position="top right"
        hoverable
      >
        <div>
          {popup.title && (
            <div className="header" style={styleHeader}>
              {popup.title}
            </div>
          )}
          {popup.content && <div className="content">{popup.content}</div>}
        </div>
      </Popup>
    );
  }
}

MenuItemPopup.propTypes = {
  menuItem: PropTypes.objectOf(PropTypes.object).isRequired,
  popup: PropTypes.objectOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.object,
    })
  ).isRequired,
  mode: PropTypes.string,
};

MenuItemPopup.defaultProps = {
  mode: null,
};
